﻿export { Settings };
import { get as getProjection } from 'ol/proj.js';
import Projection from 'ol/proj/Projection.js';
import { register } from 'ol/proj/proj4.js';
import proj4 from 'proj4';  

/**
 * Class Settings do mapa
 * @param {object} mapSettings, An object with the map settings
 */
const Settings = function (mapSettings) {
    // Define this
    var mySettings = this;

    this._mapSettings = mapSettings;

    // -- begin public variable -------------------------------------------------------------------

    // Scales array
    this.scales = [
        16000000,
        8000000,
        4000000,
        2000000,
        1000000,
        500000,
        250000,
        125000,
        50000,
        25000,
        10000,
        5000,
        2000,
        1000,
        500,
        200,
        100,
        50
    ];

    // Resolution array
    this.resolutions = [
        4480,
        2240,
        1120,
        560,
        280,
        140,
        70,
        35,
        13.999999999999998,
        6.999999999999999,
        2.8,
        1.4,
        0.5599999999999999,
        0.28,
        0.14,
        0.056,
        0.028,
        0.014
    ];

    // Extent array
    this.extent;

    // Ponta delgada
    this.center;

    // Hash proj4
    this.hashProj4;

    // Hash proj4
    this.hashLayerProperty;

    // Projection map
    this.projection;

    // Projection map 4326
    this.projectionWgs84 = getProjection('EPSG:4326');

    this.projection3035;

    // Zoom
    this.zoom = 5;

    // Operation visible
    this.operationVisible = {};

    // Operation visible
    this.searchToponymy;

    // User info
    this.userInfo = {
        userId: null,
        list_role: null,
        list_department: null
    }

    if (mySettings._mapSettings && mySettings._mapSettings.operation_visible.GoToCodObraCadastro) {

        $.ajax({
            type: 'GET',
            url: '/rest/app/Service/GetUserContractorByUserID?userId=' + this._mapSettings.additional_params.user_id,
            async: true,
            dataType: "json",
            contentType: "application/json;",
            success: function (data) {

                if (data.result && data.result.cod_contractor)
                    mySettings.userInfo.Empreiteiro = data.result.cod_contractor;

            },
            error: function (request, status, error) {
            }
        });



    }

    // Result WMST GetCapabilities
    this._resultWmtsGetCapabilities = {};

    // -- end public variable ---------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Init settings
     */
    this.Init = function () {
        var projectionStr = 'EPSG:' + this._mapSettings.map_info.srs_srid;
        mySettings.hashProj4 = this._mapSettings.hash_proj4;
        proj4.defs(projectionStr, this._mapSettings.hash_proj4[projectionStr].proj4Text);
        proj4.defs("EPSG:3305", this._mapSettings.hash_proj4["EPSG:3305"].proj4Text);
        register(proj4);
        const projection = new Projection({
            code: 'EPSG:3305',
            extent: [1896628.62, 1095703.18, 7104179.2, 6882401.15]
        });
        mySettings.projection3035 = projection; //getProjection('EPSG:3035');
        mySettings.extent = JSON.parse(this._mapSettings.map_info.extent);
        mySettings.center = JSON.parse(this._mapSettings.map_info.center);
        mySettings.projection = getProjection(projectionStr);
        mySettings.zoom = this._mapSettings.map_info.initial_zoom_level;
        mySettings.operationVisible = this._mapSettings.operation_visible;
        mySettings.treeMap = this._mapSettings.tree_map;
        mySettings.columnTableReferenceData = this._mapSettings.column_table_reference_data;
        mySettings.baseMap = this._mapSettings.base_map;
        mySettings.userInfo.userId = this._mapSettings.user_info.id_user;
        mySettings.userInfo.userName = this._mapSettings.user_info.user_name;
        mySettings.userInfo.list_role = this._mapSettings.user_info.list_role;
        mySettings.userInfo.list_department = this._mapSettings.user_info.list_department;
        mySettings.searchToponymy = this._mapSettings.search_toponymy;
        mySettings.configurationInfo = this._mapSettings.configuration_info;
        //mySettings.hashLayerProperty = app.sgs.Map.layerTree.GetFeaturePropertyByName(getObjects(mySettings.treeMap, 'layerName', _freguesiaLayer));
    };

    this.getVisibleOperations = function () {
        return mySettings.operationVisible;
    };

    /**
     * Fill hash of freguesia
     */
    this.InithashLayerPropertyfreguesia = function (layerName, allColumn) {
        mySettings.hashLayerPropertyfreguesia = app.sgs.Map.layerTree.GetFeaturePropertyByName(app.sgs.Map.layerTree.FindLayerInfoOnListLayer(layerName), allColumn);
    };

    /**
     * Add layer of freguesia
     */
    this.getInithashLayerPropertyfreguesia = function () {

        return mySettings.hashLayerPropertyfreguesia;
    };

    // -- end public method -----------------------------------------------------------------------
};